/**
 * Blog languages — kept apart from src/lib/blogPosts.ts so the app shell
 * (App.tsx route list) can use them without pulling in every article body.
 */
export type BlogLang = 'hr' | 'en' | 'sl' | 'de' | 'it';

export const SUPPORTED_LANGS: BlogLang[] = ['hr', 'en', 'sl', 'de', 'it'];
